module.exports = __webpack_public_path__ + "static/media/reNewProcess.ecbd2cc8.svg";